import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsBasBlocksList from "../created-list-inner-pages/tms-sm-bas-blocks-list";
import TmsBlocksCreation from "../creation-inner-pages/tms-bas-blocks-creation";
const BuildingBlock = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Block Creation
        </Button>
      </Row>
      <br />
      {!visible && <TmsBasBlocksList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"Building Block Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsBlocksCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default BuildingBlock;
